export const REPORT_WINDOW_ID = '5_1';

export const REPORT_WINDOW_KEY = `window_${REPORT_WINDOW_ID}`;
